// import state from '../state'
import { q1O } from '../util/nE';
import Flickity from 'flickity';
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

class HorizontalCard {
  constructor(el) {
    this.el = el;
    this.listenerActive = false;
    this.hasHover = this.el.classList.contains('has-hover');
    this.btn = this.el.querySelector('.horizontal-card__icon');
  }
  handleClick() {
    const hasActive = this.el.classList.contains('active');
    if (!hasActive) {
      this.el.classList.add('active');
    } else {
      this.el.classList.remove('active');
    }
  }
  handleResize() {
    if (window.innerWidth <= 768 && this.hasHover) {
      if (!this.listenerActive) {
        this.listenerActive = true;

        this.btn.addEventListener('touchstart', this.handleClick.bind(this));
      }
    } else {
      this.btn.removeEventListener('touchstart', this.handleClick);
      this.listenerActive = false;
    }
  }
  init() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  destroy() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }
}

export default HorizontalCard;



//////////////////
// WEBPACK FOOTER
// ./scripts/components/HorizontalCard.js
// module id = 49
// module chunks = 0